/**
 * ProtectedRoute - keeps pages private
 * ------------------------------------
 * Wrap any page that should only be seen by certain people:
 *
 *   <ProtectedRoute><Dashboard /></ProtectedRoute>            any logged-in user
 *   <ProtectedRoute role="student"><MyWork /></ProtectedRoute>  students only
 *
 * If nobody is logged in we send them to the login page, remembering where
 * they were trying to go so they land there afterwards.
 */

import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from '../hooks/useAuth';
import { useI18n } from '../hooks/useI18n';
import Loader from './Loader';

export default function ProtectedRoute({ children, role = null }) {
  const { t } = useI18n();
  const { user, loading } = useAuth();
  const location = useLocation();

  // Still checking the saved token - don't redirect yet or we would bounce
  // people out of their own pages on every refresh.
  if (loading) return <Loader label={t('common.checkingLogin')} />;

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (role && user.role !== role) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
